module.exports = __webpack_public_path__ + "client/img/s_item_09.c483d8ae.png";